import React from 'react';
import { Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import { connect } from "react-redux";
import { getHostUrl, hasPermission } from '../../store/apiWrapper';
import classnames from "classnames";
import MainHeader from './mainHeader';

import './headersCommon.scss'

class SkyMinderHeader extends React.Component {
    render() {
        return (<>
            <MainHeader label="SkyMinder.ServiceName" shadowed={false} {...this.props} />
            {!this.props.isMobile && <div className={classnames('tabs tabs-subheader shadowed', { 'tinted': this.props.tinted })}>
                <ul style={{ border: "none" }}>
                    {!hasPermission(null, "SkyMinderRegistered") && <li className="tab-link is-active">
                        <span>
                            <Translate id='SkyMinder.OrderForm' />
                        </span>
                        <div className="search-progress-short"></div>
                    </li>}
                    {hasPermission(null, "SKYPriceList") && <li className="tab-link">
                        <a href={this.getDownloadLink("SP")} target="_blank"><Translate id='SkyMinder.PriceList' /></a>
                    </li>}
                    {hasPermission(null, "SkyMinderRegistered") && <li className="tab-link">
                        <a href={this.getDownloadLink("SM")} target="_blank"><Translate id='SkyMinder.UserManual' /></a>
                    </li>}
                </ul>
            </div>}
        </>)
    }

    getDownloadLink = (type) => {
        return `${getHostUrl()}/files/skyminder/${type}`;
    }
}

export default withRouter(connect(
    state => ({ ...state, user: state.userContext }),
)(SkyMinderHeader));